<div class="card dpm-card w-100 p-3">
  <div class="row">
    <div style="margin-left:10px ;width: 50px;">
      <a href="dist/DPM/assets/Report_4101K1.pdf" class="btn btn-primary px-2 py-2 text-left" target="_black">
        <h5>Asset No. : Equipment4101K1</h5>
        <p>This is the predictive analtics report of the asset</p>
        <span class="btn btn-white btn-sm">View Report <i class="lnr lnr-chevron-right"></i></span>
      </a>
    </div>
    <div style="margin-left:140px ;width: 50px;">
      <a href="" class="btn btn-primary px-2 py-2 text-left" target="_black">
        <h5>Asset No. : Equipment4101K2</h5>
        <p>This is the predictive analtics report of the asset</p>
        <span class="btn btn-white btn-sm">View Report <i class="lnr lnr-chevron-right"></i></span>
      </a>
    </div>
    <div style="margin-left:140px ;width: 50px;">
      <a href="" class="btn btn-primary px-2 py-2 text-left" target="_black">
        <h5>Asset No. : Equipment4101K3</h5>
        <p>This is the predictive analtics report of the asset</p>
        <span class="btn btn-white btn-sm">View Report <i class="lnr lnr-chevron-right"></i></span>
      </a>
    </div>
  </div>
</div>
<!-- <div class="d-flex justify-content-between align-items-center">
<div style="width: 20%"></div>
<div style="width:60%"><H3 style="text-align: center;font-family: serif; color: rgba(56, 105, 241, 0.5);">DPM AI ANALYTICS LLP</H3></div>
<div style="width: 20%; text-align: right;"><img src="dist/DPM/assets/img/DPM_LOGO1.png"  style="height: 90px; width: 150px;"></div>
  
</div> 
<br>
<br>
<div style="padding-left: 20px; padding-top: 10px; margin-left: 10px; ">
<Div>
  <H3 style="text-align:center;font-family: serif;color: rgba(56, 105, 241, 0.5);"><u>ANALYTICS REPORT</u></H3>
</Div>
<div>
  <table class="table-bordered">
    <thead>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">Date: 12-May-2022</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Report By:Dashboard Custodian</strong></td>
      </tr>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">System/Plant: Utility/Company Name</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Tag No.: U4101K1</strong></td>
      </tr>
      <tr>
        <td colspan="2">
          <p><span style="font-weight:bolder; font-size:18px;font-family: serif">Description of Asset:</span><span style="font-size:16px;font-family: serif">Twin Screw Oil Free
          Instrument Air Compressor; Failure mode considered: 2nd stage rotor seizure.</span><br>
          <span style="font-weight:bolder; font-size:18px;font-family: serif">Major parameters:</span><span style="font-size:16px;font-family: serif">Working pressure: 8.5bg; Flow: 538 NM3/hr;
          100kw/2970 rpm; 1st rotor 17,453 rpm; 2nd rotor 21,817 rpm</span>
          </p>
        </td>
      </tr>
      <tr>
        <td>
         <span style="font-weight: bolder;font-size:18px;font-family: serif">Overall Health Condition:</span><span style="color:rgba(15, 185, 9, 0.562); font-size: 16px;">NORMAL</span><span style="font-size:16px;font-family: serif">; Likelihood of Failure:None for next 3M; Risk ranking: L;</span>
          <br><span style="font-weight: bolder;font-size:18px;font-family: serif">Impact:</span><span style="font-size:16px;font-family: serif">None</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Description of Observations/Actions Taken:</span> <span style="font-size:18px;font-family: serif;">within Normal Operating region;</span><br>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Reference of Analytics:</span>
         <span style="font-size:16px;font-family: serif">Refer graphical representation for a) Primary variables, and 
                    b) Derivative variables</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Recommendation/Conclusion:</span><span style="font-size:16px;font-family: serif">None</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif; font-weight: bolder;">Additional Improvement Action (If any):</span><span style="font-size:16px;font-family: serif"> to operate & maintain as per existing practices. Monitor once a month.</span>
        </td>
      </tr>
    </thead>
  </table>
</div>
<br>
<br>
<br>
<br>
<div>
  <table class="table-bordered">
    <thead>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">Date: 12-May-2022</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Report By:Dashboard Custodian</strong></td>
      </tr>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">System/Plant: Utility/Company Name</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Tag No.: U4101K2</strong></td>
      </tr>
      <tr>
        <td colspan="2">
          <p><span style="font-weight:bolder; font-size:18px;font-family: serif">Description of Asset:</span><span style="font-size:16px;font-family: serif">Twin Screw Oil Free
          Instrument Air Compressor; Failure mode considered: 2nd stage rotor seizure.</span><br>
          <span style="font-weight:bolder; font-size:18px;font-family: serif">Major parameters:</span><span style="font-size:16px;font-family: serif">Working pressure: 8.5bg; Flow: 538 NM3/hr;
          100kw/2970 rpm; 1st rotor 17,453 rpm; 2nd rotor 21,817 rpm</span>
          </p>
        </td>
      </tr>
      <tr>
        <td>
         <span style="font-weight: bolder;font-size:18px;font-family: serif">Overall Health Condition:</span><span style="color:rgba(15, 185, 9, 0.562); font-size: 16px;">NORMAL</span><span style="font-size:16px;font-family: serif">; Likelihood of Failure:None for next 3M; Risk ranking: L;</span>
          <br><span style="font-weight: bolder;font-size:18px;font-family: serif">Impact:</span><span style="font-size:16px;font-family: serif">None</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Description of Observations/Actions Taken:</span> <span style="font-size:18px;font-family: serif;">within Normal Operating region;</span><br>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Reference of Analytics:</span>
         <span style="font-size:16px;font-family: serif">Refer graphical representation for a) Primary variables, and 
                    b) Derivative variables</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Recommendation/Conclusion:</span><span style="font-size:16px;font-family: serif">None</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif; font-weight: bolder;">Additional Improvement Action (If any):</span><span style="font-size:16px;font-family: serif"> to operate & maintain as per existing practices. Monitor once a month.</span>
        </td>
      </tr>
    </thead>
  </table>
</div>
<br>
<br>
<br>
<br>
<div>
  <table class="table-bordered">
    <thead>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">Date: 12-May-2022</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Report By:Dashboard Custodian</strong></td>
      </tr>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">System/Plant: Utility/Company Name</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Tag No.: U4101K3</strong></td>
      </tr>
      <tr>
        <td colspan="2">
          <p><span style="font-weight:bolder; font-size:18px;font-family: serif">Description of Asset:</span><span style="font-size:16px;font-family: serif">Twin Screw Oil Free
          Instrument Air Compressor; Failure mode considered: 2nd stage rotor seizure.</span><br>
          <span style="font-weight:bolder; font-size:18px;font-family: serif">Major parameters:</span><span style="font-size:16px;font-family: serif">Working pressure: 8.5bg; Flow: 538 NM3/hr;
          100kw/2970 rpm; 1st rotor 17,453 rpm; 2nd rotor 21,817 rpm</span>
          </p>
        </td>
      </tr>
      <tr>
        <td>
         <span style="font-weight: bolder;font-size:18px;font-family: serif">Overall Health Condition:</span><span style="color:rgba(15, 185, 9, 0.562); font-size: 16px;">NORMAL</span><span style="font-size:16px;font-family: serif">; Likelihood of Failure:None for next 3M; Risk ranking: L;</span>
          <br><span style="font-weight: bolder;font-size:18px;font-family: serif">Impact:</span><span style="font-size:16px;font-family: serif">None</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Description of Observations/Actions Taken:</span> <span style="font-size:18px;font-family: serif;">within Normal Operating region;</span><br>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Reference of Analytics:</span>
         <span style="font-size:16px;font-family: serif">Refer graphical representation for a) Primary variables, and 
                    b) Derivative variables</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Recommendation/Conclusion:</span><span style="font-size:16px;font-family: serif">None</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif; font-weight: bolder;">Additional Improvement Action (If any):</span><span style="font-size:16px;font-family: serif"> to operate & maintain as per existing practices. Monitor once a month.</span>
        </td>
      </tr>
    </thead>
  </table>
</div>
<br>
<br>
<br>
<br>
<div>
  <table class="table-bordered">
    <thead>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">Date: 12-May-2022</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Report By:Dashboard Custodian</strong></td>
      </tr>
      <tr>
        <td><strong style="font-size:18px;font-family: serif">System/Plant: Utility/Company Name</strong></td>
        <td><strong style="font-size:18px;font-family: serif">Tag No.: U4101K4</strong></td>
      </tr>
      <tr>
        <td colspan="2">
          <p><span style="font-weight:bolder; font-size:18px;font-family: serif">Description of Asset:</span><span style="font-size:16px;font-family: serif">Twin Screw Oil Free
          Instrument Air Compressor; Failure mode considered: 2nd stage rotor seizure.</span><br>
          <span style="font-weight:bolder; font-size:18px;font-family: serif">Major parameters:</span><span style="font-size:16px;font-family: serif">Working pressure: 8.5bg; Flow: 538 NM3/hr;
          100kw/2970 rpm; 1st rotor 17,453 rpm; 2nd rotor 21,817 rpm</span>
          </p>
        </td>
      </tr>
      <tr>
        <td>
         <span style="font-weight: bolder;font-size:18px;font-family: serif">Overall Health Condition:</span><span style="color:rgba(243, 6, 6, 0.562); font-size: 16px;">Degraded</span><span style="font-size:16px;font-family: serif">; Likelihood of Failure:High during next 3M; Risk ranking: MH;</span>
          <br><span style="font-weight: bolder;font-size:18px;font-family: serif">Impact:</span><span style="font-size:16px;font-family: serif">Production Loss 4 Hours minimum, Economic consequence: ~50,000$</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Description of Observations/Actions Taken:</span> <span style="font-size:18px;font-family: serif;">Parameters exceeded set limits;</span><br>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Reference of Analytics:</span>
         <span style="font-size:16px;font-family: serif">Refer graphical representation for a) Primary variables, and 
                    b) Derivative variables</span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif;font-weight: bolder;">Recommendation/Conclusion:</span><span style="font-size:16px;font-family: serif">Since there is sharp change from “Normal” to “Degraded” state, stop the unit, and carry out remedial action asap. </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style="font-size:18px;font-family: serif; font-weight: bolder;">Additional Improvement Action (If any):</span><span style="font-size:16px;font-family: serif">Conduct RCFA; conduct predictive analytics for the newly identified credible failure modes; and update RCM study input to generate new set of maintenance job routine.</span>
        </td>
      </tr>
    </thead>
  </table>
</div>
<br>
<br>
<br>
<br>
</div> -->